import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
// routings
import { RoutingModule } from './routing.module';
// components
import { HomeComponent } from './home/home.component';
import { InitComponent } from './init/init.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { CryptoVoucherResultComponent } from './payment-result/crypto-voucher/crypto-voucher.component';
import { TestComponent } from './test/test.component';
import { PreInitComponent } from './pre-init/pre-init.component';
import { PayByLinkResultComponent } from './payment-result/pay-by-link/pay-by-link.component';
import { PblRedirectComponent } from './pbl-redirect/pbl-redirect.component';
import { PixResultComponent } from './payment-result/pix/pix.component';
import { PecFlashResultComponent } from './payment-result/pec-flash/pec-flash.component';
import { BankTransferResultComponent } from './payment-result/bank-transfer/bank-transfer.component';
import { CommunityBankInitializeComponent } from './community-bank/community-bank-initialize.component';
import { SelectAmountComponent } from './community-bank/select-amount/select-amount.component';
import { SelectBankComponent } from './community-bank/select-bank/select-bank.component';
import { WaitingResultComponent } from './payment-result/waiting/waiting.component';
import { CryptoCustodyComponent } from './custody-crypto/custody-crypto.component';

@NgModule({
  declarations: [
    HomeComponent,
    InitComponent,
    TestComponent,
    PreInitComponent,
    PblRedirectComponent,
    CommunityBankInitializeComponent,
    // Payment Result
    PaymentResultComponent,
    CryptoVoucherResultComponent,
    PayByLinkResultComponent,
    PixResultComponent,
    PecFlashResultComponent,
    BankTransferResultComponent,
    SelectAmountComponent,
    SelectBankComponent,
    WaitingResultComponent,
    CryptoCustodyComponent,
  ],
  imports: [SharedModule, RoutingModule],
})
export class PublicModule {}
